import { useMutation } from "@tanstack/react-query";
import { func } from "prop-types";
import {
  addPlantMonitoring,
  createPlantCategory,
  getMonitoringCategory,
  getPlantCategory,
  getPlantDetailsForAutocomplete,
  updatePlantCategory,
  updatePlantLocation,
  updatePlantMonitoring,
} from "~/services/plant.service";

export function useCreatePlantMutation() {
  return useMutation((payloads) => createPlantCategory(payloads));
}
export function useUpdatePlantMutation() {
  return useMutation((payloads) => updatePlantCategory(payloads));
}
export function usePlantDetails() {
  return useMutation((payloads) => getPlantDetailsForAutocomplete(payloads));
}

export function useCreatePlantMonitoring() {
  return useMutation((payloads) => addPlantMonitoring(payloads));
}
export function useUpdatePlantMonitoring() {
  return useMutation({
    mutationFn: (payloads) => updatePlantMonitoring(payloads),
  });
}
export function useUpdatePlantLocation() {
  return useMutation((payloads) => updatePlantLocation(payloads));
}
export function usePlantCategory() {
  return useMutation((category) => getPlantCategory(category));
}
export function useMonitoringCategory() {
  return useMutation(() => getMonitoringCategory());
}
